export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/btAvncTT52VSoSYwPqTRyt/Diseno_sin_titulo_(12).png'

export const CLASSROOM_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/10c43eb4-5f27-4d16-93c7-3e0fd0024f43.jpg'
